import { selectStandardProps } from "@/utils/componentUtils";
import { Form, Select } from "antd";
import { FormItemProps } from "antd/lib/form";
import { SelectProps } from "antd/lib/select";
import { useEnumeration } from "../../../../common/api/queries";
import { EnumerationType } from "../../enums";

interface Props {
  formItemProps: FormItemProps;
  selectProps?: SelectProps<string>;
}

const AffiliatePartnerSelect = ({ formItemProps, selectProps }: Props) => {
  const affiliatePartnersEnums = useEnumeration(EnumerationType.AFFILIATE_PARTNERS);

  return (
    <Form.Item {...formItemProps}>
      <Select
        {...selectStandardProps}
        {...selectProps}
        options={affiliatePartnersEnums.map((partner) => ({ value: partner.id, label: partner.name }))}
      />
    </Form.Item>
  );
};

export default AffiliatePartnerSelect;
